import React from 'react';
import ssmLogoUrl from '../../assets/ssm_dark_logo.png';
import { GameTitleMark } from './GameTitleMark.jsx';

export function GameHud({
    state,
    t,
    soundMuted,
    onSoundToggle,
    showTimer = true,
    scorePulse = false,
}) {
    const seconds = Math.max(0, Math.ceil(state.timeLeft));
    const minutes = String(Math.floor(seconds / 60)).padStart(2, '0');
    const rest = String(seconds % 60).padStart(2, '0');
    const soundLabel = soundMuted ? t('hud.soundOff') : t('hud.soundOn');

    return (
        <div className="lp-game__hud">
            <div className="lp-game__brand">
                <div className="lp-game__logo">
                    <img
                        className="lp-game__logo-img"
                        src={ssmLogoUrl}
                        alt=""
                        width={32}
                        height={32}
                        decoding="async"
                    />
                </div>
                <div className="lp-game__brand-copy">
                    <GameTitleMark title={t('game.title')} />
                    <p className="lp-game__subtitle">{t('game.subtitle')}</p>
                </div>
            </div>

            <div className="lp-game__stat">
                <span>{t('hud.score')}</span>
                <strong className={scorePulse ? 'lp-game__stat-score--pulse' : undefined}>
                    {state.score}
                </strong>
            </div>

            {showTimer && (
                <div className="lp-game__stat">
                    <span>{t('hud.time')}</span>
                    <strong>
                        {minutes}:{rest}
                    </strong>
                </div>
            )}

            <div className="lp-game__stat">
                <span>{t('hud.lives')}</span>
                <strong
                    className="lp-game__lives"
                    aria-label={t('hud.livesAria', `${state.lives} lives`).replace(
                        '%1$s',
                        String(state.lives),
                    )}
                >
                    {'♥'.repeat(Math.max(0, state.lives))}
                </strong>
            </div>

            <button
                type="button"
                className="lp-game__sound-toggle"
                onClick={onSoundToggle}
                aria-label={t('hud.soundToggle')}
                title={soundLabel}
            >
                <span className="lp-game__sound-toggle-icon" aria-hidden>
                    {soundMuted ? '🔇' : '🔊'}
                </span>
            </button>
        </div>
    );
}
